import React from 'react';
import { css } from '@emotion/css';
import ColorTokens from '@amzn/meridian-tokens/base/color';
import Column from '@amzn/meridian/column';

const bottomBorderStyle = css({
  borderBottom: `1px solid ${ColorTokens.colorGray200}`,
});

export function CorePageHeader({
  children,
}: {
  children: React.ReactNode;
}): JSX.Element {
  return (
    <Column
      backgroundColor="subdued"
      className={bottomBorderStyle}
      spacingInset="500"
      spacing="500"
    >
      {children}
    </Column>
  );
}
